import React from 'react';
import { Button } from 'reactstrap';

import RichText from '../../Common/RichText/RichText';

class DisabledOrFavoriteQuestionItem extends React.Component {
  renderSymbols = (text) => {
    const isNewQuestion = /<\/?[a-z][\s\S]*>/i.test(text);
    let result = text || '';
    result = result.replace(/<\/p><p>/g, '<br>');
    if (!isNewQuestion) {
      result = result.replace(/</g, '&lt;');
      result = result.replace(/>/g, '&gt;');
    }

    return result;
  };

  render() {
    return (
      <div className="disabled-questions-item d-flex flex-row justify-content-between align-items-center">
        <RichText
          tag="span"
          className="textQuestion"
          html={this.renderSymbols(this.props.text)}
        />
        <Button
          color="link"
          className="btn-outline-call-to-action rounded-lg ml-4"
          onClick={() =>
            this.props.favorite
              ? this.props.removeFavoriteQuestions(
                  this.props.userId,
                  this.props.id,
                )
              : this.props.resetQuestion(this.props.id)
          }
          data-test={`remove-favorite-question-${this.props.index}-button`}
          data-id-test={this.props.id + this.props.userId}
        >
          {this.props.favorite ? 'Remove' : 'Reset'}
        </Button>
      </div>
    );
  }
}

export default DisabledOrFavoriteQuestionItem;
